// @todo name value per project
export const LOCALSTORAGE_AUTH_TOKENS_KEY = "app_ecrf_token_v1";
export const LOCALSTORAGE_AUTH_REFRESH_TOKENS_KEY = "app_ecrf_refresh_token_v1";